import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import styles from './loading-view.module.css';

export class LoadingView extends React.Component<Record<any, any>> {
    render() {
        return (
            <div className={styles['loading-view']}>
                <h2 className={styles.heading}>Searching…</h2>
                <div className={styles.icon}>
                    <LoadingIcon fill={colors.offWhiteDk} />
                </div>
            </div>
        );
    }
}
